import { render, staticRenderFns } from "./TeamPermissionsSelector.vue?vue&type=template&id=26a75b55&"
import script from "./TeamPermissionsSelector.vue?vue&type=script&lang=ts&"
export * from "./TeamPermissionsSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports